module.exports = __webpack_public_path__ + "img/ICBC-SWD-detail.9df519b7.png";